import { FC, useMemo, useState } from 'react'
import { useHistory } from 'react-router'
import { Divider, useAnalytic } from 'src/components'
import { ETrackingEvent } from 'src/enums'
import { useBehaviorMapper, useDidMountEffect } from 'src/hooks'
import { IconChevronFilled, IconMultiUser } from 'src/icons'
import { browserHistory, ERoutes, generate } from 'src/router'
import { AuthModule } from 'src/store'
import { NavItem } from '../nav-item'

interface IProps {
  expanded: boolean
}

let _expanded = true

const MAX_COMMUNITIES_TO_SHOW = 3

export const CommunityNav: FC<IProps> = ({ expanded: sidebarExpanded }) => {
  const history = useHistory()
  const [expanded, setExpanded] = useState(_expanded)
  const { eventHandler } = useAnalytic('side_nav')

  useDidMountEffect(() => {
    _expanded = expanded
  }, [expanded])

  const showChild = useMemo(() => expanded && sidebarExpanded, [expanded, sidebarExpanded])

  const communities = useBehaviorMapper(AuthModule.communities$)

  if (!communities.length) {
    return null
  }

  return (
    <nav className="fx-column px-6 relative">
      <NavItem
        mini={!sidebarExpanded}
        icon={<IconMultiUser/>}
        label={(
          <div className="fx-1 fx fx-jc-space-between fx-ai-center">
            Job Communities
            <IconChevronFilled
              rotate={expanded ? 90 : 0}
              color="currentColor"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setExpanded((prev) => !prev)
              }}
            />
          </div>
        )}
        onClick={eventHandler(ETrackingEvent.BTN_NAV_COMMUNITIES, () => setExpanded((prev) => !prev))}
      />

      {showChild && (
        <>
          {communities.slice(0, MAX_COMMUNITIES_TO_SHOW).map((community) => (
            <NavItem
              key={community.id}
              className="pl-12"
              label={community.name}
              active={history.location.pathname.startsWith(generate([ERoutes.COMMUNITY_STATE, { state: community.code }]))}
              onClick={eventHandler(ETrackingEvent.BTN_NAV_COMMUNITIES, () => {
                browserHistory.push(generate([ERoutes.COMMUNITY_STATE, { state: community.code }]))
              })}
            />
          ))}
          {communities.length > MAX_COMMUNITIES_TO_SHOW && (
            <NavItem
              className="pl-12"
              label="See All"
              onClick={eventHandler(ETrackingEvent.BTN_NAV_COMMUNITIES, () => {
                browserHistory.push(ERoutes.COMMUNITIES)
              })}
            />
          )}
          <Divider
            type="horizontal"
            borderColor="#52563E"
            style={{
              borderRightWidth: '2px',
              height: 'calc(100% - 44px)',
              position: 'absolute',
              top: '44px',
              left: '49px'
            }}
          />
        </>
      )}
    </nav>
  )
}
